import { render, staticRenderFns } from "./EmailMessageTemplateTextArea.vue?vue&type=template&id=252ac160&scoped=true"
import script from "./EmailMessageTemplateTextArea.vue?vue&type=script&lang=js"
export * from "./EmailMessageTemplateTextArea.vue?vue&type=script&lang=js"
import style0 from "./EmailMessageTemplateTextArea.vue?vue&type=style&index=0&id=252ac160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252ac160",
  null
  
)

export default component.exports